import React from 'react';
import PlaceholderPage from '../../components/PlaceholderPage';

const Lessons = () => <PlaceholderPage title="레슨 관리" description="PT/GX 레슨 일정을 관리해요." />;

export default Lessons;
